import { Box, BoxProps } from '@chakra-ui/react';
import { ReactElement, cloneElement } from 'react';
import { ProminentButtonBorder } from '../ProminentButton';

interface Props {
  interaction?: '_focus' | '_hover';
  groupInteraction?: '_groupFocusWithin' | '_groupHover';
  children: ReactElement;
}

export const ProminentWrapper = ({
  interaction = '_focus',
  groupInteraction = '_groupFocusWithin',
  children,
  ...props
}: Props & BoxProps) => {
  return (
    <Box pos="relative" p="space.2" rounded="radius.8" overflow="hidden" role="group" {...props}>
      <ProminentButtonBorder
        position="absolute"
        inset={0}
        transition="opacity 200ms ease-in-out"
        {...(groupInteraction
          ? { [groupInteraction]: { opacity: 1 }, opacity: 0 }
          : { opacity: 1 })}
      />
      {cloneElement(children, {
        bg: 'white',
        transition: 'border 200ms ease-in-out',
        [interaction]: { borderColor: 'transparent' },
      })}
    </Box>
  );
};
